import research from './research';
import design from './design';
import launch from './launch';

const directionsName = {
    RESEARCH: 'Исследование',
    DESIGN: 'Проектирование',
    LAUNCH: 'Разработка',
    LAST_LAUNCH: 'Запуск',
};

const data = {
    [directionsName.RESEARCH]: research,
    [directionsName.DESIGN]: design,
    [directionsName.LAUNCH]: launch,
};

function dataCheck(uuid, name, services) {
    return (
        typeof uuid === 'string' && uuid.length === 36
        && typeof name === 'string' && name.length > 0
        && toString.call(services) === '[object Array]'
    );
}

function addData(directions) {
    let isDataCorrect = true;
    directions.forEach(({ uuid, name, services }) => {
        // eslint-disable-next-line no-param-reassign
        if (name === directionsName.LAST_LAUNCH) name = directionsName.LAUNCH;
        isDataCorrect = isDataCorrect && dataCheck(uuid, name, services);
        data[name] = {
            ...data[name],
            uuid,
            name,
            services,
        };
    });
    return isDataCorrect;
}

function getDirectionCheckboxes() {
    return Object.values(data)
        .map(({ name, services }) => ({
            name,
            isChecked: false,
            filterID: services.map(({ uuid }) => uuid),
        }));
}

export { directionsName, addData, getDirectionCheckboxes };
export default data;
